import { Component, OnInit } from '@angular/core';
import { AsyncSubject, BehaviorSubject, of, ReplaySubject, Subject } from 'rxjs';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-reactive-js',
  templateUrl: './reactive-js.component.html',
  styleUrls: ['./reactive-js.component.css']
})
export class ReactiveJSComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    
    const dataSource: Observable<number> = of(1, 2, 3, 4, 5);
    const subscription: Subscription = dataSource.pipe( map(value => value + 1)).subscribe(value => console.log(value));
    console.log(subscription);

    const dataSource2: Observable<number> = of (50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60);
    const anotherSubscription: Subscription = dataSource2.pipe(filter(value => value <= 57)).subscribe(value => console.log(value));
    console.log(anotherSubscription);

    const dataSource3: Observable<string> = of ('casa', 'macchina', 'casa', 'amuleto', 'amuleto', 'campagna', 'avvoltoio');
    const subscription3: Subscription = dataSource3.
      pipe(
        debounceTime(200),
        distinctUntilChanged())
        .subscribe(result => {
        console.log(result);
    });

    const dataSource4: Observable<string> = of ('casa', 'macchina', 'casa', 'amuleto', 'amuleto', 'campagna', 'avvoltoio');
    const subscription4: Subscription = dataSource4.subscribe({
      next: value => console.log(value),
      error: error => console.log(error),
      complete: () => console.log('complete')
    });

    /********************** EMITS ITS (LAST) VALUE ONLY ON COMPLETION **********************/
    console.log("AsyncSubject");
    const subject01: AsyncSubject<number> = new AsyncSubject();
    let subscriber: Subscription = subject01.subscribe(value => console.log(value));
    subject01.next(123);
    const subscriber2: Subscription = subject01.subscribe(value => console.log(value));
    subject01.next(456);
    subscriber = subject01.subscribe(value => console.log(value));
    subject01.complete();

    /********* REQUIRES INITIAL VALUE; EMITS CURRENT VALUE TO NEW SUBSCRIBERS **************/
    console.log("BehaviorSubject");
    const subject02: BehaviorSubject<number> = new BehaviorSubject(123);
    let subscriber3: Subscription = subject02.subscribe(value => console.log(value));
    subject02.subscribe(console.log);
    subject02.next(999);
    subscriber3 = subject02.subscribe(value => console.log(value));
    let subscriber4: Subscription = subject02.subscribe(value => console.log(value));

    /******************** EMITS ALL OLD VALUES TO NEW SUBSCRIBERS *************************/
    console.log("ReplaySubject");
    const subject03: ReplaySubject<number> = new ReplaySubject();
    let subscriber5: Subscription = subject03.subscribe(value => console.log(value));
    subject03.next(234);
    subject03.next(79);
    let subscriber6: Subscription = subject03.subscribe(value => console.log(value));

    /******************* EMITS ITS NEW VALUE TO ACTUAL SUBSCRIBERS ************************/
    console.log("Subject");
    const subject04: Subject<number> = new Subject();
    const subscriber07: Subscription = subject04.subscribe(value => console.log(value));
    subject04.next(728);
    const subscriber08: Subscription = subject04.subscribe(value => console.log(value));
    subject04.next(340);
  }
}
